import { useIntl } from 'react-intl';

import { workChatNotFoundMessages } from './WorkChatNotFound.messages';

export type WorkChatNotFoundReason = 'not-found' | 'revoked';

export interface WorkChatNotFoundProps {
  reason?: WorkChatNotFoundReason;
}

export const WorkChatNotFound = ({ reason = 'not-found' }: WorkChatNotFoundProps) => {
  const intl = useIntl();
  const isRevoked = reason === 'revoked';

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-2 text-center"
      data-testid={isRevoked ? 'work-chat-revoked' : 'work-chat-not-found'}
    >
      <h2 className="text-base font-semibold text-text-primary">
        {intl.formatMessage(
          isRevoked
            ? workChatNotFoundMessages.revokedTitle
            : workChatNotFoundMessages.title
        )}
      </h2>
      <p className="max-w-md text-sm text-text-secondary">
        {intl.formatMessage(
          isRevoked
            ? workChatNotFoundMessages.revokedDescription
            : workChatNotFoundMessages.description
        )}
      </p>
    </div>
  );
};
